import React from "react"
import { motion } from "framer-motion"
import { FaInstagram, FaFacebookF } from "react-icons/fa"

import SectionTitle from "../common/SectionTitle"

export default function TeamSection() {
  const team = [
    {
      id: 1,
      name: "Siwar",
      role: "Coordinatrice Esthéticienne",
      image: "/images/team-1.jpg",
    },
    {
      id: 2,
      name: "Chaima",
      role: "Technicien de la forme",
      image: "/images/team-2.jpg",
    },
    {
      id: 3,
      name: "Oumaima",
      role: "Responsable Coordinatrice",
      image: "/images/team-3.jpg",
    },
  ]

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          subtitle="Notre Equipe"
          title="Des Experts Professionnels dédiés à votre Bien-être"
          description="Nos thérapeutes certifiés mettent leur expérience, leur attention et leur passion à votre service pour vous offrir la meilleure expérience spa."
        />

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {team.map((member, index) => (
            <motion.div
              key={member.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="group relative bg-[#f9f6f1] rounded-[30px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              {/* Image */}
              <div className="h-[600px] overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-90" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 w-full p-6 text-white">
                <h3 className="text-xl font-semibold">
                  {member.name}
                </h3>

                <p className="text-sm text-gray-300 mt-1">
                  {member.role}
                </p>

                {/* Socials 
                
                <div className="flex items-center gap-3 mt-4 opacity-0 group-hover:opacity-100 transition duration-500">
                  <a
                    href="#"
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#b8955d]"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    href="#"
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#b8955d]"
                  >
                    <FaInstagram />
                  </a>
                </div>
                */}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}